<template>
  <div class="index-page">
    <el-scrollbar class="index-scroll">
      <div class="index-content">
        <div class="video-box" v-if="!videoEnd">
          <video id="my-video" ref="myVideo" @click="goPano" preload="" autoplay="autoplay" loop class="video">
            <source src="video/video.mp4" type="video/mp4">
          </video>
<!--          <div class="jump-video" @click="goPano">跳过</div>-->
<!--          <div class="login-box">-->
<!--            <div class="login-form">-->
<!--              <div class="login-label"> 密码：</div>-->
<!--              <el-input v-model="passWord"></el-input>-->
<!--              <div class="login-btn" @click="handleLogin">登录</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
<!--        <div class="content-box" v-if="videoEnd">-->
<!--          <div class="index-title"></div>-->
<!--          <div class="index-bottom"></div>-->
<!--          <transition name="fade">-->
<!--            <div class="index-btn" v-if="btnShow" @click="goPano"></div>-->
<!--          </transition>-->
<!--        </div>-->
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        btnShow: false,
        // 注释视频，打开改为false
        videoEnd: false,
        passWord:"",
        rightPass:"0927"
      };
    },
    methods: {
      goPano() {
        this.$router.push({
          path: "/pagoPage",
        });
        /* 点击传递埋码 */
        window.goldlog.record("/spec.1.1", "", "snsScene=首页&product=pcweb&pagename=云上2023年品博会", "");
      },
      clickVideo() {
        this.$refs.myVideo.play();
      },
      jump() {
        this.videoEnd = true
      },
      handleLogin(){
        if (this.passWord) {
          if (this.passWord == this.rightPass) {
            this.videoEnd = true
          }else{
            this.$message.error("您输入的密码不正确");
          }
        }else{
          this.$message.error("请输入密码！");
        }
      }
    },
    mounted() {
      var that = this
      var clientWidth = document.documentElement.clientWidth;
      var clientHeight = document.documentElement.clientHeight;
      if (clientWidth / clientHeight > 1920 / 980) {
        document.querySelector(".index-content").style.width = clientWidth + "px";
        document.querySelector(".index-content").style.height =
                (clientWidth * 980) / 1920 + "px";
        // document.documentElement.style.fontSize =
        //   100 * (clientWidth / 1920) + "px";
        document.querySelector(".index-scroll .el-scrollbar__wrap").style.height =
                "100%";
        document.querySelector(".index-scroll .el-scrollbar__wrap").style.width =
                "auto";
      } else {
        document.querySelector(".index-content").style.width =
                (clientHeight * 1920) / 980 + "px";
        document.querySelector(".index-content").style.height =
                clientHeight + "px";
        // document.documentElement.style.fontSize =
        //   100 * (clientHeight / 980) + "px";
        document.querySelector(".index-scroll .el-scrollbar__wrap").style.height =
                "auto";
        document.querySelector(".index-scroll .el-scrollbar__wrap").style.width =
                "100%";
      }
      window.onresize = function () {
        var clientWidth = document.documentElement.clientWidth;
        var clientHeight = document.documentElement.clientHeight;
        if (clientWidth / clientHeight > 1920 / 980) {
          document.querySelector(".index-content").style.width =
                  clientWidth + "px";
          document.querySelector(".index-content").style.height =
                  (clientWidth * 980) / 1920 + "px";
          // document.documentElement.style.fontSize =
          //   100 * (clientWidth / 1920) + "px";
          document.querySelector(
                  ".index-scroll .el-scrollbar__wrap"
          ).style.height = "100%";
          document.querySelector(
                  ".index-scroll .el-scrollbar__wrap"
          ).style.width = "auto";
        } else {
          document.querySelector(".index-content").style.width =
                  (clientHeight * 1920) / 980 + "px";
          document.querySelector(".index-content").style.height =
                  clientHeight + "px";
          // document.documentElement.style.fontSize =
          //   100 * (clientHeight / 980) + "px";
          document.querySelector(
                  ".index-scroll .el-scrollbar__wrap"
          ).style.height = "auto";
          document.querySelector(
                  ".index-scroll .el-scrollbar__wrap"
          ).style.width = "100%";
        }
      };

      // 打开视频需要放开注释
      // this.$refs.myVideo.addEventListener("ended", function () {
      //   that.videoEnd = true
      // });

      setTimeout(() => {
        this.btnShow = true;
      }, 1000);
    },
  };
</script>

<style lang="scss" scoped>
  .index-page {
    width: 100%;
    height: 100%;
    background-color: #ffffff;

    .index-content {
      width: 100%;
      height: 100%;
      background-image: url("../../../assets/img/index-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;

      .content-box {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
      }

      .index-title {
        width: 1581px;
        height: 473px;
        background-image: url("../../../assets/img/index-title.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 100px;
        left: calc(50% + 10px);
        transform: translate(-50%, 0);
        animation: dropDown 1s ease-in-out;
      }

      .index-btn {
        width: 353px;
        height: 148px;
        background-image: url("../../../assets/img/index-btn.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 670px;
        left: 49%;
        margin-left: -128px;
        cursor: pointer;

        // &:hover {
        //   background-image: url("../../../assets/img/index-btn-hover.png");
        // }
      }

      .index-bottom {
        width: 100%;
        position: absolute;
        bottom: -50px;
        left: 0%;
        width: 1920px;
        height: 384px;
        background-image: url("../../../assets/img/index-text.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        // color: #ffffff;
        // text-align: center;
        // font-size: 23px;
        // line-height: 29px;
        .bottom-text {}

        // .center-text {
        //   margin-left: 0.75rem;
        //   margin-right: 0.3rem;
        // }
      }
    }

    .video-box {
      top: -110px;
      left: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #C6060F;

      .video {
        width: 1920px;
        height: 1080px;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
      }

      .jump-video {
        position: absolute;
        top: 100px;
        right: 100px;
        color: #ffffff;
        font-size: 24px;
        cursor: pointer;
      }

      .login-box {
        width: 500px;
        height: 100px;
        position: absolute;
        top: 200px;
        left: 50%;
        margin-left: -250px;
        align-items: center;
        justify-content: space-around;
      }
      .login-form{
        display: flex;
        font-size: 18px;
        color: #fff;
        .login-btn{
          width: 100px;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          background-color: #DF8903;
          margin-left: 20px;
          cursor: pointer;
        }
        .login-label{
          width: 100px;
          line-height: 40px;
        }
      }

    }

    @keyframes dropDown {
      0% {
        top: 0;
        opacity: 0;
      }



      100% {
        top: 100px;
        opacity: 1;
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to

      /* .fade-leave-active below version 2.1.8 */
    {
      opacity: 0;
    }
  }
</style>
<style>
  .index-scroll {
    width: 100%;
    height: 100%;
  }

  .index-scroll .el-scrollbar__wrap {
    overflow: hidden;
    height: auto;
    width: auto;
  }
</style>